import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { EventsService } from 'src/app/services/events-service/events.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { EMPTY, Subscription } from 'rxjs';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { ActivatedRoute } from '@angular/router';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';

@Component({
  selector: 'app-events-event-dashboard',
  templateUrl: './events-event-dashboard.component.html',
  styleUrls: ['./events-event-dashboard.component.scss']
})
export class EventsEventDashboardComponent implements OnInit, OnDestroy {

  alert;
  centerList;
  mailProviders;
  availableApplications;
  availableDesks;
  availableIotDevices;
  refreshAlertSubscriptionRefresh: Subscription;
  getAlertInfoSubscription: Subscription;
  getCompanyMailProvidersSubscription: Subscription;
  getAlertApplicationsSubscription: Subscription;
  getAlertDesksSubscription: Subscription;
  getAlertIotSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
    private eventsService: EventsService,
    private centerService: CentersCentersService,
    private snackbarService: SnackBarService,
    private activatedRoute: ActivatedRoute,
    private headerBreadcrumbService: HeaderBreadcrumbService,
    private desksTurnsService: DesksTurnsService) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getAlertInfo();
    this.centerList = this.userStorageService.getCenterList();
    this.refreshAlertSubscriptionRefresh = this.eventsService.refreshAlertListen().subscribe(
      (res) => {
        this.getAlertInfo();
      }
    );
  }

  private getAlertInfo() {
    const internalId = this.activatedRoute.snapshot.params['eventid'];
    this.getAlertInfoSubscription = this.eventsService.getAlertInfo(internalId).pipe(
      tap(o => this.alert = o),
      tap(o => this.getCompanyMailProviders()),
      tap(o => this.getAlertApplications()),
      tap(o => this.getAlertDesks()),
      tap(o => this.getIotDevices()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getCompanyMailProviders() {
    this.getCompanyMailProvidersSubscription = this.eventsService.getCompanyMailProviders(this.alert.CenterInternalId).pipe(
      tap(o =>  this.mailProviders = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getAlertApplications() {
    this.getAlertApplicationsSubscription = this.eventsService.getAlertApplications(this.alert.CenterInternalId).pipe(
      tap(o => this.availableApplications = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getAlertDesks() {
    this.getAlertDesksSubscription = this.desksTurnsService.getDesks().pipe(
      tap(o => this.availableDesks = (o as Array<any>).filter((ad) => ad.CenterInternalId === this.alert.CenterInternalId)),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getIotDevices() {
    this.getAlertIotSubscription = this.centerService.getIotDevices(this.alert.CenterInternalId).pipe(
      tap(o => this.availableIotDevices = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-exclamation-circle', 'events-page.event detail', 'account/events', [new BRoute('account-page.account', 'account'), new BRoute('events-page.events', 'account/events'), new BRoute('events-page.event detail')]));
  }

  ngOnDestroy() {
    if (this.refreshAlertSubscriptionRefresh) { this.refreshAlertSubscriptionRefresh.unsubscribe(); }
    if (this.getAlertInfoSubscription) { this.getAlertInfoSubscription.unsubscribe(); }
    if (this.getCompanyMailProvidersSubscription) { this.getCompanyMailProvidersSubscription.unsubscribe(); }
    if (this.getAlertApplicationsSubscription) { this.getAlertApplicationsSubscription.unsubscribe(); }
    if (this.getAlertDesksSubscription) { this.getAlertDesksSubscription.unsubscribe(); }
    if (this.getAlertIotSubscription) { this.getAlertIotSubscription.unsubscribe(); }
  }

}
